import { createApp } from 'vue';
import SearchDrawer from './SearchDrawer.vue';
import SearchFull from './SearchFull.vue';

createApp(SearchDrawer).mount('[data-js-cludo="search-drawer"]');
createApp(SearchFull).mount('[data-js-cludo="search-full"]');
